module.exports = __webpack_public_path__ + "img/awards.7de69017.jpg";